/**
 * اسکلتِ صفحه‌ی گفت‌وگوها تا حامی داخل iframe برسد — شبیه تلگرام، به‌جای «لطفا کمی صبر کنید».
 * فهرست: سربرگ و ردیف‌های کم‌رنگ. داخلِ یک گفت‌وگو: سربرگ و چند حباب پیام.
 */
const LIST_WIDTHS: Array<[string, string]> = [
  ['w-1/2', 'w-4/5'],
  ['w-2/5', 'w-3/4'],
  ['w-3/5', 'w-11/12'],
  ['w-1/3', 'w-2/3'],
  ['w-1/2', 'w-4/5'],
  ['w-2/5', 'w-3/5'],
  ['w-1/2', 'w-3/4'],
];

const BUBBLES: Array<{ mine: boolean; w: string; h: string }> = [
  { mine: false, w: 'w-3/5', h: 'h-10' },
  { mine: true, w: 'w-1/2', h: 'h-8' },
  { mine: false, w: 'w-2/3', h: 'h-14' },
  { mine: true, w: 'w-2/5', h: 'h-8' },
  { mine: false, w: 'w-1/2', h: 'h-10' },
];

const Bar = ({ className }: { className: string }) => (
  <span className={`block animate-pulse rounded-md bg-slate-200 ${className}`} />
);

export const ChatsSkeleton = ({ chatDetail = false }: { chatDetail?: boolean }) => (
  <div
    className="absolute inset-0 z-10 flex h-full w-full flex-col bg-white"
    role="status"
    aria-label="در حال بارگذاری گفت‌وگوها"
    dir="rtl"
  >
    {chatDetail ? (
      <>
        <div className="flex h-14 items-center gap-3 border-b border-slate-100 px-4">
          <span className="block h-9 w-9 animate-pulse rounded-full bg-slate-200" />
          <div className="flex flex-1 flex-col gap-2">
            <Bar className="h-3 w-1/3" />
            <Bar className="h-2.5 w-1/5" />
          </div>
        </div>
        <div className="flex flex-1 flex-col justify-end gap-3 bg-slate-50 px-4 py-4">
          {BUBBLES.map((b, i) => (
            <div key={i} className={`flex ${b.mine ? 'justify-start' : 'justify-end'}`}>
              <span className={`block animate-pulse rounded-2xl ${b.mine ? 'bg-blue-100' : 'bg-slate-200'} ${b.w} ${b.h}`} />
            </div>
          ))}
        </div>
        <div className="flex h-16 items-center gap-2 border-t border-slate-100 px-3">
          <span className="block h-11 flex-1 animate-pulse rounded-full bg-slate-100" />
          <span className="block h-11 w-11 animate-pulse rounded-full bg-slate-200" />
        </div>
      </>
    ) : (
      <>
        <div className="flex h-14 items-center justify-between px-4">
          <span className="text-base font-bold text-slate-800">گفت‌وگوها</span>
          <span className="block h-7 w-7 animate-pulse rounded-full bg-slate-200" />
        </div>
        <div className="flex flex-col">
          {LIST_WIDTHS.map(([title, line], i) => (
            <div key={i} className="flex items-center gap-3 px-4 py-2.5">
              <span className="block h-12 w-12 shrink-0 animate-pulse rounded-full bg-slate-200" />
              <div className="flex flex-1 flex-col gap-2">
                <Bar className={`h-3 ${title}`} />
                <Bar className={`h-2.5 ${line}`} />
              </div>
            </div>
          ))}
        </div>
      </>
    )}
  </div>
);
